export default __webpack_public_path__ + "static/media/dp.0135858e.png";